module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "produk"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Pembayaran',
          href: '#/produk',
          exact: true,
        },
        {
          text: 'Paket'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Paket Belajar")]), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v("\n            Daftar Paket\n            "), _c('v-spacer'), _c('v-btn', {
    staticClass: "align-center text-body-2 blew white--text",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.createProduk()
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n                Paket\n            ")], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "items": _vm.produkList,
      "headers": _vm.headers,
      "hasAction": true,
      "has-custom-pagination": false,
      "custom-pagination-total-items": _vm.produkList.length,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.pagination.totalPages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode,
      "loading": _vm.isLoading
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.updateProduk()
      },
      "deleted": function($event) {
        return _vm.confirmDelete($event)
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key]
        }
      }
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "450"
    },
    model: {
      value: (_vm.dialogConfirm.open),
      callback: function($$v) {
        _vm.$set(_vm.dialogConfirm, "open", $$v)
      },
      expression: "dialogConfirm.open"
    }
  }, [_c('dialog-confirm', {
    attrs: {
      "title": _vm.dialogConfirm.title,
      "subtitle": _vm.dialogConfirm.subtitle
    },
    on: {
      "close": function($event) {
        _vm.dialogConfirm.open = false;
        _vm.dialogConfirm.title = null;
        _vm.dialogConfirm.function = null;
      },
      "confirm": function($event) {
        _vm.deleteProduk(_vm.dialogConfirm.function);
        _vm.dialogConfirm.open = false;
        _vm.dialogConfirm.title = null;
        _vm.dialogConfirm.function = null;
      }
    }
  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cced4ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/pembayaran/components/Produk.vue
// module id = 1998
// module chunks = 1